module.exports = __webpack_public_path__ + "static/media/headSearch_bg.ddabb336.png";